import { ref } from 'vue';
import contractAbi from './abi/abi1.json';
import Web3 from 'web3';

export const useGetRegionDailyRewardAmount = () => {
 

  // Web3 初始化
  const web3 = new Web3('https://rpc.dbcwallet.io'); // 替换为你的 RPC 节点
  const contractAddress = '0xc663EE691f98D80E5F1cCE3c9ad53a14dA676A23'; // 替换为实际合约地址

  const contract = new web3.eth.Contract(contractAbi, contractAddress);
  // 调用合约方法计算奖励
  async function getRegionDailyRewardAmountH(region) {
    try {
      // 先计算算力值
      if (!region) {
        window.$message.error('请填写完整的参数');
        return false;
      }
      // 调用合约方法
      const result = await contract.methods.getRegionDailyRewardAmount(
        region
        )
        .call();
      console.log( `地域：${region}，value：${result}` );
      const rewardValue = Number(web3.utils.fromWei(result.toString(), 'ether')).toFixed(5);
      return rewardValue;
    } catch (error) {
      console.error('Error fetching rewards:', error);
   
    }
  }


  // 计算链上收益
  // 新增 preCalculateRewards 函数
  async function preCalculateRewards(region, calcPoint, nftCount, reserveAmount) {
    try {
      // 参数校验
      if (!region || calcPoint === undefined || nftCount === undefined || reserveAmount === undefined) {
        window.$message.error('请填写完整的参数');
        return false;
      }

      // 调用合约方法 preCalculateRewards
      const result = await contract.methods
        .preCalculateRewards(
          region, // string memory region
          calcPoint, // uint256 calcPoint
          nftCount, // uint256 nftCount
          web3.utils.toWei(reserveAmount.toString(), 'ether')
        )
        .call();

      console.log(result, '预计算当日奖励原始结果');
      // 将结果从 Wei 转换为 Ether，并保留 5 位小数
      const rewardValue = Number(web3.utils.fromWei(result.toString(), 'ether')).toFixed(5);
      console.log(rewardValue, '预计算当日奖励');
      return rewardValue;
    } catch (error) {
      console.error('Error pre-calculating rewards:', error);
      return false;
    }
  }

  
  return {
    getRegionDailyRewardAmountH,
    preCalculateRewards
  };
};
